import "../src/globals/root.scss";
import "./globals/theme.scss";
import "./App.css";
import { useEffect, useState } from "react";
import { AuthUserProvider } from "./authUserProvider";
import AppRouter from "./router";
import { bootstrapDevSession, hasStoredSession, isDevSessionEnabled } from "./helpers/devSession";
import { initNotiflixTheme } from "./ui";
import { initSidebarCollapsed } from "./helpers/sidebarCollapse";

// Apply the design tokens to every Notiflix dialog before any page mounts.
initNotiflixTheme();
// Restore the saved desktop sidebar width before first paint so the content
// column doesn't jump once the sidebar mounts.
initSidebarCollapsed();

function App() {
  // Local dev only (see helpers/devSession.ts): when a dev refresh token is
  // configured and there is no session yet, mint one before the router mounts
  // so route gating and `Main`'s localStorage rehydration see a signed-in user
  // on first render. In every other case this resolves synchronously.
  const [sessionReady, setSessionReady] = useState(() => !isDevSessionEnabled() || hasStoredSession());

  useEffect(() => {
    if (sessionReady) return;
    let cancelled = false;
    bootstrapDevSession().finally(() => {
      if (!cancelled) setSessionReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, [sessionReady]);

  return (
    <AuthUserProvider>
      <div className="App">
        {sessionReady && <AppRouter />}
      </div>
    </AuthUserProvider>
  );
}

export default App;
